import { supabase } from '@/integrations/supabase/client';

/**
 * ⛔ SO ENTRA SE O CODIGO REALMENTE LEU (Douglas 23/09/2026)
 *
 * A regua de "qual e a fatura deste cliente" estava escrita a mao em cada tela,
 * cada uma diferente — e a ficha do lead nao tinha nenhuma: pegava o ultimo
 * created_at, lido ou nao. Anexo vazio ficava na frente da fatura boa e a
 * proposta saia sem linha (471 CNPJs assim em 23/09/2026).
 *
 * Aqui e' um lugar so. Tela nova NAO escreve a regua de novo: chama isto.
 */
export const CAMPOS_FATURA_VALIDA =
  'id, created_at, arquivo_url, linhas_detectadas, conta_numero, periodo_fim, origem, leitura_metodo, metadata';

/**
 * De onde a conta veio. A tela dizia "Fatura baixada" para um PDF que o
 * consultor tinha ANEXADO a mao — e no caso A KASPER (23/09/2026) isso fez o
 * time acreditar que o Bee havia trazido a conta, quando o Bee nunca trouxe
 * nada daquele CNPJ. Origem e fato, nao detalhe.
 */
export function comoAFaturaChegou(origem?: string | null): string {
  const o = String(origem || '').toLowerCase();
  if (o === 'webhook_bee360' || o === 'bee360' || o === 'auto_robo') return 'Baixada pelo Bee';
  if (o === 'gerente_claro') return 'Enviada pelo Gerente Claro';
  if (o === 'manual' || o === 'em_massa') return 'Anexada no CRM';
  return 'Recebida';
}

export async function buscarUltimaFaturaValida(clienteId: string) {
  const { data, error } = await supabase
    .from('fatura_upload')
    .select(CAMPOS_FATURA_VALIDA)
    .eq('cliente_id', clienteId)
    .is('recusada_em', null)
    .is('duplicada_de', null)
    .not('periodo_fim', 'is', null)
    .not('conta_numero', 'is', null)
    .gt('linhas_detectadas', 0)
    // ⛔ A QUARTA condição, e ela faltava: leitura DESCARTADA não é fatura.
    // Na A KASPER o anexo de 14/09 teve a leitura descartada em 16/09 mas ficou
    // com conta, período e 4 linhas preenchidos — os 4 telefones INVENTADOS.
    // Ele passava nos três primeiros filtros e era escolhido, enquanto a leitura
    // boa do mesmo dia estava ao lado marcada como duplicata dele.
    .not('metadata->>status', 'eq', 'REVISAO_MANUAL')
    .order('created_at', { ascending: false })
    .limit(5);

  if (error) throw error;
  // A conta FIXA anexada na triagem Faturas não é a fatura do cliente: a
  // proposta de renovação lê a conta móvel (Douglas 14/10/2026).
  return (data || []).find((f) => (f.metadata as { tipo_conta?: string } | null)?.tipo_conta !== 'FIXA') ?? null;
}

/**
 * COMO a conta foi lida. Documento com texto e imagem escaneada nao sao a mesma
 * prova, e a tela tem que dizer qual das duas esta mostrando.
 *
 * A leitura por imagem roda a 400 DPI, le cada pagina DUAS vezes de formas
 * diferentes, so aceita o que as duas concordam, confere a operadora de cada
 * numero e exige que a soma feche com o total da conta. Mesmo assim ela NAO
 * entrega GB nem minutos — esses ficam em branco, nunca chutados.
 */
export function comoAFaturaFoiLida(metodo?: string | null): {
  rotulo: string; detalhe: string; confiavel: boolean;
} | null {
  if (String(metodo || '').toUpperCase() === 'IMAGEM') {
    return {
      rotulo: 'Lida de imagem',
      detalhe:
        'A conta veio escaneada, sem texto. Números e valores foram lidos em alta resolução, '
        + 'com dupla leitura e conferência da soma. GB e minutos não aparecem numa fatura em imagem.',
      confiavel: true,
    };
  }
  if (String(metodo || '').toUpperCase() === 'TEXTO') {
    return { rotulo: 'Lida do documento', detalhe: 'A conta veio com texto e foi lida direto do documento.', confiavel: true };
  }
  return null;
}
